import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/filterAutoexclusionUsers'; // Importing filter component
import TableAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/tableAutoexclusionUsers'; // Importing table component
import DetailsAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/detailsAutoexclusionUsers'; // Importing details component
import RecordAutoexclusionUsers from 'views/customers/reports/autoexclusionUsers/recordAutoexclusionUsers'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the autoexclusion users view.
 * @extends JetView
 */
export default class autoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Configuration for the right section of the layout
            type: 'wide',
            minWidth: 200,
            rows: [DetailsAutoexclusionUsers], // Including details component
        };
        const toolbar = {
            // Configuration for the toolbar
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };
        const left = {
            // Configuration for the left section of the layout
            height: screen.width < 500 ? 700 : 600, // Responsive height based on screen width
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying current theme
                    elements: [
                        {
                            view: 'label', // Label element
                            label: _('Autoexclusión'), // Localized label text
                            width: 300,
                        },
                    ],
                },
                FilterAutoexclusionUsers, // Including filter component
                TableAutoexclusionUsers, // Including table component
                toolbar, // Including toolbar
            ],
        };
        webix.ui.fullScreen(); // Setting the UI to full screen mode
        return {
            // Returning the main configuration object
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Main view type
            height: 'auto', // Automatic height adjustment
            rows: [
                {
                    responsive: 'a5', // Responsive behavior for the row
                    type: 'wide', // Type of the row
                    cols: [left, right], // Columns layout with left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
